import React from "react";
import PropTypes from "prop-types";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

import { useUpdateRoleAssignmentsMutation } from "state/rtkQuery/access/accessMutations";
import { buildSetActivePayload } from "utils/accessManagement/roleAssignmentForm";
import { getAssigneeDisplay } from "utils/accessManagement/roleAssignmentDisplay";
import { useAccessPlatformId } from "utils/accessManagement/useAccessPlatformId";
import { showToast } from "utils/reusableToast";

const DeactivateOrgAssignmentDialog = ({ assignment, onClose }) => {
  const [updateAssignments, { isLoading }] = useUpdateRoleAssignmentsMutation();
  const { platformId } = useAccessPlatformId();

  if (!assignment) return null;

  const { primary } = getAssigneeDisplay(assignment);

  const handleConfirm = async () => {
    try {
      const result = await updateAssignments(buildSetActivePayload([assignment.id], false, assignment.platform_id || platformId)).unwrap();
      if (result.not_updated?.length) {
        showToast({ title: "Deactivation failed", description: result.not_updated[0]?.message, type: "error" });
      } else {
        showToast({ title: "Access deactivated", description: `${primary} no longer has access from this assignment.`, type: "success" });
      }
      onClose();
    } catch {
      showToast({ title: "Deactivation failed", description: "Please try again.", type: "error" });
    }
  };

  return (
    <Dialog open={!!assignment} onClose={onClose}>
      <DialogTitle>Deactivate access?</DialogTitle>
      <DialogContent sx={{ maxWidth: 400 }}>
        <DialogContentText>
          <strong>{primary}</strong> will no longer have access to this organization from this assignment. You can
          reactivate it later if needed.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>Cancel</Button>
        <Button onClick={handleConfirm} disabled={isLoading} color="warning" variant="contained">
          Deactivate
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeactivateOrgAssignmentDialog.propTypes = {
  assignment: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};

export default DeactivateOrgAssignmentDialog;
